<template>
  <h2 class="h4 my-3">
    <slot></slot>
  </h2>
</template>
